require('@/config/bugsnag')
require('@/config/plugins')
require('@/config/directives')
require('@/config/global-components')
require('@/config/notyf')
